export default __webpack_public_path__ + "static/media/app-store.5a77d7aa.png";